import axios from '../../common/utils/interceptor';
import { apiUrls, SessionStore } from '../../constants';

export const getSurveyTriggerCodes = async (tcPlusFlow: boolean): Promise<{ data?: string[]; error: string }> => {
  const res = { data: undefined, error: '' };
  if (!tcPlusFlow) {
    try {
      const { data: responseData } = await axios.get(apiUrls.GET_SURVEY_TRIGGER_CODES);
      if (responseData.IsError) {
        res.error = responseData.Message;
      } else {
        res.data = responseData.Data[0].triggerCodes;
        sessionStorage.setItem(SessionStore.surveyTriggerCodes, JSON.stringify(res.data));
      }
    } catch (error) {
      res.error = 'error';
      console.error('Failed while fetching survey trigger codes');
    }
  }
  return res;
};
